import React from "react";
import SectionContentImparare from "../SectionContentImparare";
import SectionContentCapire from "../SectionContentCapire";
import SectionContentAgire from "../SectionContentAgire";
import {CustomTabs, CustomTabPanel, CustomTabList, CustomTab} from "./styles";

export default function Tabs(props) {
  return (
    <CustomTabs>
      <CustomTabList>
        <CustomTab>IMPARARE</CustomTab>
        <CustomTab>CAPIRE</CustomTab>
        <CustomTab>AGIRE</CustomTab>
      </CustomTabList>
      <CustomTabPanel>
        <SectionContentImparare
          pos={props.pos}
          mainTitleFirstPart={"LA SCIENZA"}
          mainTitleSecondPart={"DEI CAMBIAMENTI CLIMATICI"}
          checkPoints={[
            "Cos’è il clima, come si studia e come cambia",
            "L’urgenza della crisi climatica attuale",
            "Gli effetti sugli ambienti e sulla vita",
            "Alla ricerca delle soluzioni",
          ]}
          description={
            "Partiamo dalle basi, partiamo dalla scienza. Per capire quello che sta succedendo sul nostro Pianeta e come possiamo agire è importante prima di tutto conoscere i cambiamenti climatici. Un argomento vasto e complesso che può essere raccontato anche ai più piccoli. Con i materiali di questa sezione puoi guidare gli “Agenti 0 emissioni” nella preparazione del loro equipaggiamento speciale."
          }
          videoTitle={"I CAMBIAMENTI CLIMATICI IN 7 MINUTI"}
          infographicTitle={"DUE INFOGRAFICHE DA APPENDERE IN CLASSE"}
          lessonsTitle={"MATERIALI PER FORMARE AGENTI SPECIALI"}
          lessonDescription={
            "Cliccando sui pulsanti di seguito puoi visualizzare le presentazioni e scaricare le schede da utilizzare in classe per spiegare cosa sono i cambiamenti climatici ai tuoi studenti, quali effetti hanno e cosa possiamo fare per affrontarli."
          }
          quizTitle={"PROVE PER “AGENTI 0 EMISSIONI”"}
          quizDescription={
            "Assicurati che i tuoi studenti abbiano tutti gli strumenti necessari per passare alla prossima missione! Usa i quiz per riprendere e fissare gli argomenti delle lezioni."
          }
          certificateTitle={"MISSIONE COMPIUTA!"}
          certificateDescription={
            "Ora davvero i cambiamenti climatici non hanno più segreti. Scarica l’attestato di classe di questa sezione e guida gli “Agenti 0 emissioni” nella prossima sfida. La sezione CAPIRE vi aspetta!"
          }
          linksTitle={"APPROFONDIMENTI"}
        />
      </CustomTabPanel>
      <CustomTabPanel>
        <SectionContentCapire
          pos={props.pos}
          mainTitleFirstPart={"VIVERE IN UN PIANETA"}
          mainTitleSecondPart={"PIÙ CALDO"}
          checkPoints={[
            "Giustizia e ingiustizia climatiche",
            "Conflitti e migrazioni ambientali",
            "Cambiamenti climatici e diritti dei bambini",
          ]}
          description={
            "Perché un Pianeta più caldo è anche più ingiusto? Con i materiali di questa sezione puoi guidare gli “Agenti 0 emissioni” alla scoperta degli effetti dei cambiamenti climatici sulla vita delle persone, in ogni parte del mondo. Ambiente, povertà, migrazioni, conflitti… tutto è collegato in un delicato equilibrio che degli agenti speciali devono saper riconoscere e comprendere per poter passare all’azione."
          }
          videoTitle={"TITOLO VIDEO"}
          infographicTitle={"DUE INFOGRAFICHE DA APPENDERE IN CLASSE"}
          lessonsTitle={"MATERIALI PER FORMARE AGENTI SPECIALI"}
          lessonDescription={
            "Cliccando sui pulsanti di seguito puoi visualizzare le presentazioni e scaricare le schede da utilizzare in classe per parlare di giustizia climatica  in classe, presentare e scoprire alcuni esempi pratici degli effetti dei cambiamenti climatici sulla vita delle persone e in particolare su quella dei bambini."
          }
          quizTitle={"PROVE PER “AGENTI 0 EMISSIONI”"}
          quizDescription={
            "Assicurati che i tuoi studenti abbiano tutti gli strumenti necessari per passare alla prossima missione! Usa i quiz per riprendere e fissare gli argomenti delle lezioni."
          }
          certificateTitle={"MISSIONE COMPIUTA!"}
          certificateDescription={
            "Gli “Agenti 0 emissioni” hanno aggiunto al loro equipaggiamento la comprensione del delicato equilibrio tra uomo e ambiente. Scarica l’attestato di classe di questa sezione e guidali nella prossima sfida, la più importante: la sezione AGIRE vi aspetta!"
          }
          linksTitle={"APPROFONDIMENTI"}
        />
      </CustomTabPanel>
      <CustomTabPanel>
        <SectionContentAgire
          pos={props.pos}
          mainTitleFirstPart={"STRUMENTI E PRATICHE"}
          mainTitleSecondPart={"PER PASSARE ALL'AZIONE"}
          checkPoints={[
            "Efficienza energetica",
            "Mobilità sostenibile",
            "Public speaking",
            "Advocacy",
            "Dibattito argomentativo",
          ]}
          description={
            "Le fasi di preparazione sono completate e gli “Agenti 0 emissioni” sono pronti per l’ultima missione: l’attivazione. In questa sezione trovi i materiali per fornire ai tuoi studenti le armi segrete per affrontare questa importante sfida: proposte di azioni per ridurre l’impatto della scuola, istruzioni e strategie per far sentire la propria voce e coinvolgere tutta la comunità."
          }
          videoTitle={"#naturenow - Greta Thunberg"}
          lessonsTitleOne={"MISSIONE | RIDUZIONE"}
          lessonsTitleTwo={"MISSIONE | FAI SENTIRE LA TUA VOCE"}
          lessonDescriptionTwo={
            "Tre strumenti per permettere agli “Agenti 0 emissioni” di affrontare il pubblico: superare le paure e coinvolgere chi ascolta, difendere una causa, argomentare le proprie idee."
          }
          certificateTitle={"MISSIONE COMPIUTA!"}
          certificateDescription={
            "Gli “Agenti 0 emissioni” hanno portato a termine anche la sfida più difficile e hanno conquistato la licenza ad agire. Scarica l’attestato personale di questa sezione che riconosce il loro impegno."
          }
          linksTitle={"APPROFONDIMENTI"}
        />
      </CustomTabPanel>
    </CustomTabs>
  );
}
